import styled from 'styled-components'

const TestimonialsTitle = styled.h2`
  color: #304760;
  font-size: 36px;
  font-weight: 300;
  margin-top: 0;
  margin-bottom: 2em;
  text-align: center;

  /* Extra Small Devices, Phones */ 
  @media only screen and (max-width : 480px){
    font-size: 1.5em;
  }
`
export default TestimonialsTitle



// WEBPACK FOOTER //
// ./src/components/Testimonials/TestimonialsTitle.js